document.addEventListener('DOMContentLoaded', function() {
  (function(){
    const totalMs = 548 * 60 * 1000;
    const key = 'flashSaleEnd';
    let end = localStorage.getItem(key);

    if (!end || parseInt(end, 10) <= Date.now()) {
      end = Date.now() + totalMs;
      localStorage.setItem(key, end);
    } else {
      end = parseInt(end, 10);
    }

    function update() {
      let diff = end - Date.now();

      if (diff <= 0) {
        end = Date.now() + totalMs;
        localStorage.setItem(key, end);
        diff = totalMs;
      }

      document.getElementById('days').textContent =
        String(Math.floor(diff / 86400000)).padStart(2,'0');
      document.getElementById('hours').textContent =
        String(Math.floor((diff % 86400000) / 3600000)).padStart(2,'0');
      document.getElementById('minutes').textContent =
        String(Math.floor((diff % 3600000) / 60000)).padStart(2,'0');
      document.getElementById('seconds').textContent =
        String(Math.floor((diff % 60000) / 1000)).padStart(2,'0');
    }

    update();
    setInterval(update, 1000);
  })();
});




(function () {
    var el = document.querySelector('[data-splash]');
    if (!el) return;

    var sets = [
      {
        d: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/splash_d_01_394873bf-e715-4857-b149-6fc3278ec063.jpg?v=1767789586')",
        m: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/splash_m_01_a1a36c5e-15c4-47fc-b2ea-127b58dd2e2e.jpg?v=1767789585')"
      },
      {
        d: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/splash_d_02_2dbaaf06-311b-4f5f-91f5-42604edfdc81.jpg?v=1767789585')",
        m: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/splash_m_02_f751b934-4494-4436-8bab-782f53f87ec3.jpg?v=1767789585')"
      }
    ];

    var choice = sets[Math.floor(Math.random() * sets.length)];

    el.style.setProperty('--splash-desktop', choice.d);
    el.style.setProperty('--splash-mobile', choice.m);
  })();